import { createApi } from '@reduxjs/toolkit/query/react'
import { isValid, isValidArray } from '../../utility/helpers/common'
import ApiEndpoints from '../../utility/http/ApiEndpoints'
import { axiosBaseQuery } from '../../utility/http/Http'
import {
  RequestParamsWithPagePerPage,
  RequestParamsWithParentId,
  ResponseParamsType,
  ResponseParamsTypeWithPagination,
  ViewParams
} from '../../utility/http/httpConfig'
import { ProductOfferType } from '../../views/ProductManagement/fragment/ProductForm'
import { CategoryParamsType } from '../../views/stores/category/CategoryAddForm'

interface extraParams {
  jsonData?: any
  id?: any
}

type ListRequestParams = (RequestParamsWithPagePerPage & extraParams) | undefined
type ListParentParams = RequestParamsWithParentId & extraParams
type ResponseParams = ResponseParamsTypeWithPagination<CategoryParamsType>
type ResponseOfferParams = ResponseParamsType<ProductOfferType>
type CatsParams = ResponseParamsType<Array<CategoryParamsType>>
type CatsParam = ResponseParamsType<CategoryParamsType>

export const CompanyManagement = createApi({
  reducerPath: 'CompanyManagement',
  tagTypes: ['Companies'],
  baseQuery: axiosBaseQuery(),
  endpoints: (builder) => ({
    loadCompany: builder.mutation<any, ListRequestParams>({
      query: (a) => ({
        jsonData: a?.jsonData,
        params: { page: a?.page, per_page_record: a?.per_page_record },
        method: 'post',
        path: 'administration/companies'
      })
    }),

    createOrUpdateCompany: builder.mutation<ResponseParams, CategoryParamsType>({
      query: (jsonData) => ({
        jsonData,
        method: isValid(jsonData?.id) ? 'patch' : 'post',
        path: isValid(jsonData?.id)
          ? ApiEndpoints?.store_company + jsonData?.id
          : ApiEndpoints.store_company
      })
      // invalidatesTags: ['Categories']
    }),

    deleteCompanyById: builder.mutation<ResponseParams, ViewParams>({
      invalidatesTags: ['Companies'],
      //   query: ({ id }) => ({
      //     method: 'delete',
      //     path: ApiEndpoints.delete_category + id
      //   })
      query: ({ id, originalArgs, jsonData }) => ({
        jsonData,
        method: 'delete',
        path: ApiEndpoints.administration_company + id
      })
    })
  })
})
export const {
  useCreateOrUpdateCompanyMutation,
  useLoadCompanyMutation,
  useDeleteCompanyByIdMutation
} = CompanyManagement
